<script setup lang="ts">
import { useField } from 'vee-validate';
import { computed, toRef, useAttrs } from 'vue';
import type { FormAttrs, VeeRadioButtonGroupProps } from '../types';
import { useVeeFormProps } from '../utils';

const emits = defineEmits<{
  change: [value: unknown];
}>();

const props = defineProps<VeeRadioButtonGroupProps>();

const veeProps = useVeeFormProps(props);
const passdownProps = computed(() => ({
  ...veeProps.value,
  label: undefined,
}));

const attrs = useAttrs() as FormAttrs;
const passdownAttrs = computed(() => ({
  ...attrs,
  class: undefined,
}));

const { errorMessage, value, handleChange, setTouched } = useField<unknown>(
  toRef(() => props.name),
);

function onUpdate(data: unknown) {
  const targetData = data ?? props.defaultData;
  handleChange(targetData);
  setTouched(true);
  emits('change', targetData);
}
</script>

<template>
  <div :class="$attrs.class">
    <v-label v-if="label">{{ label }}</v-label>

    <v-radio-group
      v-bind="{ ...passdownProps, ...passdownAttrs }"
      :readonly="passdownProps.mode === 'details'"
      :modelValue="value"
      :hint="errorMessage || hint"
      :error="Boolean(errorMessage)"
      :persistentHint="Boolean(errorMessage) || persistentHint"
      @update:modelValue="onUpdate"
    >
      <slot></slot>
    </v-radio-group>
  </div>
</template>
